import React, { useState } from 'react';
import {Link,Outlet} from 'react-router-dom';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import { Accordion } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';

// css
import  'Assets/css/LoginMain.css';
import "Assets/css/AppLogin.css";
import GlbFtrUi from 'Views/Glb/GlbFtrUi';


const AppLoginLayout = () => {
    // 모바일 가로모드 감지
    const [isLandscapeMobile, setIsLandscapeMobile] = useState(isMobile && window.innerWidth > window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setIsLandscapeMobile(isMobile && window.innerWidth > window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return (
        <>
        <div className='loginWrap appLoginWrap'>
            <div className="loginContainer">
                <img src={process.env.PUBLIC_URL + '/images/Connect/Login/ConnectLogo.png'} alt="Logo"/>
                <Outlet />
            </div>
        </div>
        </>
    );
}
export default AppLoginLayout;